<template>
  <div :class="{ overlay }" class="loading-icon">
    <div class="lds-ellipsis">
      <div v-for="n in 4" :key="n"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-icon {
  @extend %centered;

  &.overlay {
    @extend %overlay;
    position: absolute;
    z-index: 1;
    background: rgba(255, 255, 255, 0.7);
  }
}

.lds-ellipsis {
  position: relative;
  min-width: 64px;
  min-height: 25px;

  div {
    position: absolute;
    top: 7px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: map-get($map: $colors, $key: primary);
    animation-timing-function: cubic-bezier(0, 1, 1, 0);

    &:nth-child(1) {
      left: 6px;
      animation: lds-ellipsis1 0.6s infinite;
    }

    &:nth-child(2) {
      left: 6px;
      animation: lds-ellipsis2 0.6s infinite;
    }

    &:nth-child(3) {
      left: 26px;
      animation: lds-ellipsis2 0.6s infinite;
    }

    &:nth-child(4) {
      left: 45px;
      animation: lds-ellipsis3 0.6s infinite;
    }
  }
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
</style>
